<template>
    <div>
        <div class="card">
            <div class="card-header animated fadeInRightBig" >
                <div class="card-title">Ponto Manual</div>      
            </div>
            <div class="card-body">
                <div class="row mb-4">
                    <div class="col-md-12">
                        <label><span class="required">*</span> Usuário:</label>
                        <select class='form-control' v-model="manualCheck.user_id">
                                <option :value="user.id" v-for="user in users" :key="user.id">{{ user.name }}</option>
                            </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 offset-md-3">
                        <label><span class="required">*</span> Data</label>
                        <input type="date" class="form-control" v-model="manualCheck.date">
                    </div>
                    <div class="col-md-3">
                        <label><span class="required">*</span> Tempo</label>
                        <input type="text" class="form-control" v-model="manualCheck.time" v-mask="'##:##:##'" placeholder="HH:MM:SS">
                    </div>
                </div>
                <div class="block text-right">
                    <router-link to="/manualChecks" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <p><span class="required">*</span> Campos Obrigatórios</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                users: [],
                manualCheck: {
                    user_id: '',
                    time: '',
                    date: ''
                }
            }
        },
        methods: {
            save: function () {
                const self = this;

                if(self.manualCheck.id) return self.edit();

                const api = this.$store.state.api + 'checks/manualCheck';

                let fd = self.makeFormData();
                if(!fd) return;

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Ponto manual cadastrado com sucesso`, 'success');
                        this.$router.push('/manualChecks');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            edit: function () {
                const self = this;
                const api = self.$store.state.api + 'checks/' + self.manualCheck.id;

                let fd = self.makeFormData();
                if(!fd) return;

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Ponto manual editado com sucesso`, 'success');
                        this.$router.push('/manualChecks');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            makeFormData: function(){
                const self = this;

                let fd  = new FormData();

                if(!self.manualCheck.time || self.manualCheck.time.length < 8){
                    self.$message('Erro', 'Preencha horas válidas', 'error');
                    return false;
                }

                fd.append('user_id', self.manualCheck.user_id);
                fd.append('datetime', self.manualCheck.date + ' ' + self.manualCheck.time);
                console.log(self.manualCheck.date + ' ' + self.manualCheck.time)
                fd.append('manual', 1);

                if(self.manualCheck.id) {
                    fd.append('id', self.manualCheck.id);
                    fd.append('_method', 'PUT');
                }

                return fd;
            },
            getUsers: function(){
                const self = this;
                const api = this.$store.state.api + 'users?paginated=false';

                self.$http.get(api)
                    .then((response) => {
                        self.users = response.data.data;
                    })
                    .catch((error) => {
                        self.$message('Erro', error.response.data, 'error');
                    });
            },
            getManualCheck: function(id){
                let self = this;
                let api  = self.$store.state.api + 'manualChecks/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.manualCheck = response.data.data[0];
                    })
                    .catch((error) => {
                        self.errors = error.response.data;
                        self.$message(null, self.errors, 'error');
                    });
            },
        },
        mounted: function(){
            const self = this;

            self.getUsers();

            let id = self.$route.params.id;
            if(id) {
                self.getManualCheck(id);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ManualCheck/Add.vue